// extracted by mini-css-extract-plugin
export var active = "header-module--active--ee33e";
export var alertContainer = "header-module--alertContainer--043ad";
export var consistentlyNavigationMenu = "header-module--consistentlyNavigationMenu--13f69";
export var headerLogoText = "header-module--headerLogoText--8b22e";
export var headerMain = "header-module--headerMain--cc1a7";
export var headerNavigation = "header-module--headerNavigation--ff4bc";
export var navTrigger = "header-module--navTrigger--08a3c";
export var score = "header-module--score--25dd7";
export var search = "header-module--search--1f340";
export var searchOverlay = "header-module--searchOverlay--d2480";
export var stickyNav = "header-module--stickyNav--496fc";
export var unifiedHeader = "header-module--unifiedHeader--64076";
export var user = "header-module--user--4cb7d";
export var userLink = "header-module--userLink--4b669";